import React, { lazy } from 'react';
export function Footer() {
  return <footer className="bg-dark py-6 px-4 border-t border-dark-border text-center" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <div className="mb-3" data-id="element-79">
          <a href="https://jumpbox.ar/" target="_blank" rel="noopener noreferrer" className="inline-block mb-1" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/fo1U8NeLj8g66kqHNGXdMc/logo_jb_10x10.jpg" alt="JumpBox Logo" loading="lazy" decoding="async" className="h-12 w-auto rounded-lg mx-auto" data-id="element-81" />
          </a>
          <p className="text-neon font-medium text-xs tracking-widest uppercase" data-id="element-82">
            Performance Deportivo
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 text-xs text-gray-600" data-id="element-83">
          <span data-id="element-84">© 2025 JumpBox</span>
          <span className="hidden md:inline" data-id="element-85">•</span>
          <a href="https://jumpbox.ar" className="hover:text-neon transition-colors" data-id="element-86">
            jumpbox.ar
          </a>
          <span className="hidden md:inline" data-id="element-87">•</span>
          <a href="https://instagram.com/jumpbox.ar" className="hover:text-neon transition-colors" data-id="element-88">
            @jumpbox.ar
          </a>
          <span className="hidden md:inline" data-id="element-89">•</span>
          <span data-id="element-90">Mar del Plata, Argentina</span>
        </div>
      </div>
    </footer>;
}